import { useData } from "@hooks/useData";
import { ID } from "@datassential/platform-ui-lib";
import { iReportProPublication } from "@models/ReportProPublication";
import { components } from "@apiSchema";
import http from "@core/fetch";
import apiConfig from "@apiConfig";

type Data = {
    items: Map<ID, iReportProPublication[]>;
};

const DEFAULT_DATA: Data = {
    items: new Map(),
};

const REQUEST_TYPE: keyof typeof apiConfig = 'get category lens all macs';
type MacItem = components['schemas']['MacSearchResultShort'];
type Response = components['schemas']['MacSearchResultByLNRCategory'][];

function mapMac(item: MacItem): iReportProPublication {
    return {
        id: item.id ?? 0,
        title: item.title ?? '',
        thumbnail: item.imageUrl ?? '',
        createdDate: item.modifyDate ?? '',
    } as iReportProPublication;
}

async function getHomeCategoryLensAllMacs(): Promise<Data> {
    try {
        const response: Response = await http.get(REQUEST_TYPE, {
            count: 6,
        });

        const items = new Map<ID, iReportProPublication[]>();

        (response ?? []).forEach(cat => {
            items.set((cat.id ?? 0) as ID, (cat.macs ?? []).map(mapMac));
        });

        return { items };
    } catch (err) {
        console.error('Fetch error:', REQUEST_TYPE, err);
        return DEFAULT_DATA;
    }
}

export function useHomeCategoryLensAllMacs() {
    return useData(DEFAULT_DATA, getHomeCategoryLensAllMacs);
}
